import React from 'react';
import { linkFields } from '@/forms/state/state';
import CatalogueObjectInputs from './CatalogueObjectInputs';

const CatalogueLinkList = ({
  category,
  code,
  field,
  section,
}) => (
  <CatalogueObjectInputs
    category={category}
    code={code}
    field={field}
    fields={linkFields(field)}
    section={section}
  />
);

export default CatalogueLinkList;
